module.exports = __webpack_public_path__ + "img/bg_intro_1_3_mb.9226faee.png";